export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/tattoo_design.4255954.svg";